export default __webpack_public_path__ + "static/media/portatambor.4b342cd8.png";